module.exports = __webpack_public_path__ + "img/mask-curvey-polygon.f4986bf6.svg";